module.exports = __webpack_public_path__ + "static/media/mail.20e8982e.svg";